import { Component, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { IconButtonComponent } from '@kinomap-dev/ng-ui-lib/buttons';
import { ColorType } from '@kinomap-dev/ng-ui-lib/core';

type Visibility = 'hidden' | 'visible';

@Component({
  selector: 'app-toolbar-dock',
  imports: [IconButtonComponent],
  templateUrl: './toolbar-dock.component.html',
  styleUrl: './toolbar-dock.component.scss',
})
export class ToolbarDockComponent {
  iconColor: InputSignal<ColorType> = input.required<ColorType>();
  isHidden: InputSignal<boolean> = input<boolean>(false);
  toolbarState: WritableSignal<Visibility> = signal<Visibility>('hidden');

  toggleToolbar(): void {
    this.toolbarState.set(this.toolbarState() === 'visible' ? 'hidden' : 'visible');
  }
}
